import Swiper from 'swiper';
import { Pagination, Grid } from 'swiper/modules';

export const initBenefitsSlider = () => {
  const slider = document.querySelector('.benefits__slider');
  
  if (!slider) return;

  let swiperInstance = null;
  const breakpoint = window.matchMedia('(min-width: 992px)');

  const initSwiper = () => {
    if (breakpoint.matches) {
      // Десктоп: уничтожить Swiper
      if (swiperInstance) {
        swiperInstance.destroy(true, true);
        swiperInstance = null;
      }
    } else {
      // Мобильный: инициализировать Swiper
      if (!swiperInstance) {
        swiperInstance = new Swiper(slider, {
          modules: [Pagination, Grid],
          slidesPerView: 1,
          spaceBetween: 16,
          grid: {
            rows: 2,
            fill: 'row'
          },
          pagination: {
            el: '.benefits__pagination',
            clickable: true,
            bulletClass: 'swiper-pagination-bullet',
            bulletActiveClass: 'swiper-pagination-bullet-active',
          },
        });
      }
    }
  };

  // Инициализация при загрузке
  initSwiper();

  // Отслеживание изменения размера окна
  breakpoint.addEventListener('change', initSwiper);
};

